<template>
  <div class="vendor-form">
    <p class="vendor-form-label">{{ label }}</p>
    <div class="form-list-usaha">
      <div class="list-usaha">
        <div class="list-usaha-content list-usaha-content__title">
          <p v-for="(table, index) in tables" :key="index" :class="table.css">
            {{ table.name }}
          </p>
        </div>
        <div
          class="list-usaha-content"
          v-for="(list, index) in model"
          :key="index"
        >
          <p v-for="(table, index) in tables" :key="index" :class="table.css">
            {{ list[table.obj_name] }}
          </p>
        </div>
      </div>
      <div @click="openModal()" class="btn-landing-icons" v-if="!disabled">
        <p class="icons-btn-landing">+</p>
        <a class="text-btn-landing">Tambah</a>
      </div>

      <addIUJP
        v-if="$store.state[storeName][modalName]"
        :label="label"
        :storeName="storeName"
        :modelName="modelName"
        :mutationName="mutationName"
        :modalName="modalName"
      />
    </div>
  </div>
</template>
<script>
import addIUJP from '@/components/customModal/addIUJP.vue'
export default {
  props: [
    'label',
    'storeName',
    'modelName',
    'mutationName',
    'modalName',
    'tables',
    'disabled',
  ],
  components: { addIUJP },
  computed: {
    model: function() {
      return this.$store.state[this.storeName][this.modelName]
    },
  },
  methods: {
    openModal() {
      this.$store.commit(this.mutationName, {
        name: this.modalName,
        value: true,
      })
    },
  },
}
</script>
